import './FixedComponents.css';
const FixedComponents = () => {
    return(
        
            <a href={'https://wa.me/5511950742962'} id={"whatsapp-btn"} target={"_blank"}>
                <i className='fa-brands fa-whatsapp'></i>
            </a>
        
    )
};

export default FixedComponents;